<mat-toolbar class="mat-toolbar-azul">
  <img [src]="logoVisorWeb" width="250" height="auto" fxHide.xs>
  <img [src]="logoVisorWeb" width="200" height="90%" fxHide.xs fxHide.sm fxHide.lg fxHide.md
    fxHide.xl>
  <span class="text-container">Condiciones APU (FCAS y Costos Indirectos)</span>
  <button mat-icon-button (click)="closeDialogCondicionesApu()" class="menu-button">
    <mat-icon matSuffix>close</mat-icon>
  </button>
</mat-toolbar>
<mat-card class="card-grey">
  <mat-card-content style="padding-top: 1rem;">
    <form [formGroup]="condicionesApuForm" (ngSubmit)="onSubmit()">
      <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px" fxLayout.sm="column" fxLayout.xs="column">
        <mat-form-field fxLayout="column" appearance="outline" floatLabel="always" class="input-width-275">
            <mat-label>Referencia:</mat-label>
            <input matInput formControlName="referencia" name="referencia" minlength="4" maxlength="100" autocomplete="off"
              required>
            <mat-error *ngIf="condicionesApuForm.controls['referencia'].hasError('required')">Campo
              requerido.</mat-error>
          </mat-form-field>
          <mat-form-field fxLayout="column" appearance="outline" floatLabel="always" class="input-width-275">
            <mat-label>Descripción:</mat-label>
            <input matInput formControlName="descripcion" name="descripcion" minlength="4" maxlength="100"
              autocomplete="off" required>
            <mat-error *ngIf="condicionesApuForm.controls['descripcion'].hasError('required')">Campo
              requerido.</mat-error>
          </mat-form-field>
      </div>
      <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px" fxLayout.sm="column" fxLayout.xs="column">
        <div>
          <mat-form-field fxLayout="column" appearance="outline" floatLabel="always" class="input-width-275">
            <mat-label>Prestaciones(%):</mat-label>
            <input matInput formControlName="prestaciones" name="prestaciones" minlength="1" maxlength="6"
              autocomplete="off" required>
            <mat-error *ngIf="condicionesApuForm.controls['prestaciones'].hasError('required')">Campo requerido.</mat-error>
            <mat-error *ngIf="condicionesApuForm.controls['prestaciones'].hasError('pattern')">Solo números.</mat-error>
          </mat-form-field>
        </div>
        <div>
          <mat-form-field fxLayout="column" appearance="outline" floatLabel="always" class="input-width-275">
            <mat-label>Administración(%):</mat-label>
            <input matInput formControlName="administracion" name="administracion" minlength="1" maxlength="6"
              autocomplete="off" required>
            <mat-error *ngIf="condicionesApuForm.controls['administracion'].hasError('required')">Campo requerido.</mat-error>
            <mat-error *ngIf="condicionesApuForm.controls['administracion'].hasError('pattern')">Solo números.</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px" fxLayout.sm="column" fxLayout.xs="column">
        <div>
          <mat-form-field fxLayout="column" appearance="outline" floatLabel="always" class="input-width-275">
            <mat-label>Utilidad(%):</mat-label>
            <input matInput formControlName="utilidad" name="utilidad" minlength="1" maxlength="6" autocomplete="off"
              required>
            <mat-error *ngIf="condicionesApuForm.controls['utilidad'].hasError('required')">Campo requerido.</mat-error>
            <mat-error *ngIf="condicionesApuForm.controls['utilidad'].hasError('pattern')">Solo números.</mat-error>
          </mat-form-field>
        </div>
        <div>
          <mat-form-field fxLayout="column" appearance="outline" floatLabel="always" class="input-width-275">
            <mat-label>Financiamiento(%):</mat-label>
            <input matInput formControlName="financiamiento" name="financiamiento" minlength="1" maxlength="6"
              autocomplete="off" required>
            <mat-error *ngIf="condicionesApuForm.controls['financiamiento'].hasError('required')">Campo requerido.</mat-error>
            <mat-error *ngIf="condicionesApuForm.controls['financiamiento'].hasError('pattern')">Solo números.</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px" fxLayout.sm="column" fxLayout.xs="column">
        <div>
          <mat-form-field fxLayout="column" appearance="outline" floatLabel="always" class="input-width-275">
            <mat-label>I.V.A.(%):</mat-label>
            <input id="txtIva" matInput formControlName="iva" name="iva" minlength="1" maxlength="6"
              autocomplete="off" required>
            <mat-error *ngIf="condicionesApuForm.controls['iva'].hasError('required')">Campo requerido.</mat-error>
            <mat-error *ngIf="condicionesApuForm.controls['iva'].hasError('pattern')">Solo números.</mat-error>
            <mat-error *ngIf="condicionesApuForm.controls['iva'].hasError('minlength')">Mínimo 1 caracter.</mat-error>
            <mat-error *ngIf="condicionesApuForm.controls['iva'].hasError('maxlength')">Máximo 2 caracteres.</mat-error>
          </mat-form-field>
        </div>
        <div>
          <mat-form-field fxLayout="column" appearance="outline" floatLabel="always" class="input-width-275">
            <mat-label>Otros Imp.(%):</mat-label>
            <input matInput formControlName="otrosImp" name="otrosImp" minlength="1" maxlength="6" autocomplete="off"
              required>
            <mat-error *ngIf="condicionesApuForm.controls['otrosImp'].hasError('required')">Campo requerido.</mat-error>
            <mat-error *ngIf="condicionesApuForm.controls['otrosImp'].hasError('pattern')">Solo números.</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div *ngIf="!applyIvaBudget" fxLayout="column" fxLayoutAlign="center center" class="div-img-detalle"
        style="padding: 0.5rem;">
        <h3 fxLayout="row" style="font-weight: bold;">¡IMPORTANTE!</h3>
        <p fxLayout="row" style="text-align: justify;">Recuerde Homologar si desea mantener una sola condición (%)
          para todas las partidas. Especialmente si adicionó o mezcló con Partidas de diferentes Base de Datos o de otros
          Presupuestos.</p>
        <button mat-raised-button (click)="onSubmitAll()" fxLayout="row" type="button" class="align-center-middle">
          <span class="text-icon-space">Homologar todas las partidas</span>
        </button>
      </div>
      <div fxLayout="row" fxLayoutAlign="center stretch" fxLayoutGap="20px" fxLayout.sm="row" fxLayout.xs="column"
        style="padding-top: 1rem;">
        <div fxLayout="column">
          <button mat-raised-button class="buttons-text-center" color="warn" type="button" (click)="closeDialogCondicionesApu()"
            class="align-center-middle">
            <span class="text-icon-space">Regresar</span>
            <mat-icon>restart_alt</mat-icon>
          </button>
        </div>
        <div fxLayout="column" *ngIf="editar">
          <button mat-raised-button class="buttons-text-center" color="primary" type="button" (click)="habilitarCampos()"
            class="align-center-middle">
            <span class="text-icon-space">Editar</span>
            <mat-icon>save</mat-icon>
          </button>
        </div>
        <div fxLayout="column" *ngIf="!editar">
          <button mat-raised-button class="buttons-text-center" color="primary" type="summit" class="align-center-middle">
            <span class="text-icon-space">Guardar</span>
            <mat-icon>save</mat-icon>
          </button>
        </div>
      </div>
    </form>
  </mat-card-content>
</mat-card>